var map = {
	"./ave2/ave02.png": "634f",
	"./ave2/ave04.png": "87a1",
	"./ave2/eleganza4_product.webp": "aca1",
	"./ave2/logo.png": "a992",
	"./ave2/logo.svg": "90b0",
	"./ave2/navigation/01_2_Linet_Ave_2_Retractable_Foot_Section.jpg": "0f6c",
	"./ave2/navigation/Safety_Comfort.jpg": "b490",
	"./ave2/navigation/accesories.jpg": "4312",
	"./ave2/navigation/colors/Blue.jpg": "1ded",
	"./ave2/navigation/colors/DuoCoat.jpg": "110b",
	"./ave2/navigation/colors/Orange.jpg": "acbd",
	"./ave2/navigation/colors/Pink.jpg": "c9c3",
	"./ave2/navigation/colors/Violet.jpg": "532b",
	"./ave2/navigation/colors/Yellow.jpg": "e364",
	"./ave2/navigation/comfort.jpg": "daea",
	"./ave2/navigation/positioning.jpg": "4ab1",
	"./ave2/navigation/safety.jpg": "fca6",
	"./eleganza4/eleganza.png": "727b",
	"./eleganza4/eleganza4_product.webp": "a675",
	"./eleganza4/logo.png": "d9cd",
	"./eleganza4/logo.svg": "3e50",
	"./eleganza4/navigation/key_features--comfort.png": "6f2b",
	"./eleganza4/navigation/key_features--controls.png": "9ce7",
	"./eleganza4/navigation/key_features--mobilization.png": "2e85",
	"./eleganza4/navigation/key_features--safety.png": "54f7",
	"./eleganza4/navigation/modifications--with_mattras.jpg": "f58d",
	"./eleganza4/navigation/modifications--without_mattras.jpg": "e4ce",
	"./eleganza4/navigation/solution--early-mobilization.jpg": "fb71",
	"./eleganza4/navigation/solution--falls-prevention.jpg": "67f7",
	"./eleganza4/navigation/solution--improve-patient-experience.jpg": "6ef4",
	"./eleganza4/navigation/solution--pressure-injury-prevention.jpg": "4fdd",
	"./eleganza4/navigation/solution--safe-patient-moving-and-handling.jpg": "606a",
	"./gracie/gracie.png": "7029",
	"./gracie/logo.png": "d49f",
	"./gracie/navigation/ACCESORIES.jpg": "3c60",
	"./gracie/navigation/COMFORT.jpg": "3fd1",
	"./gracie/navigation/COMPLEX_SOLUTION.jpg": "28a8",
	"./gracie/navigation/EASY_OF_OPERATION.jpg": "caaa",
	"./gracie/navigation/FULL_HD_VIDEO_COLPOSCOPE.jpg": "d2bd",
	"./gracie/navigation/NO_EXTRAS.jpg": "f181",
	"./gracie/navigation/POSITIONING.jpg": "2dfb",
	"./gracie/navigation/TOOL_TROLLEY.jpg": "dcc8",
	"./gracie/navigation/colors/Blue.jpg": "a200",
	"./gracie/navigation/colors/Green.jpg": "f7b5",
	"./gracie/navigation/colors/Lavender.jpg": "4c6a",
	"./gracie/navigation/colors/Orange.jpg": "3882",
	"./gracie/navigation/colors/Yellow.jpg": "bcae",
	"./multicare/content/acp.jpg": "0e20",
	"./multicare/content/gap.jpg": "505a",
	"./multicare/content/ibrake.jpg": "db40",
	"./multicare/content/lateral-therapy.jpg": "bb6d",
	"./multicare/content/multiboard.jpg": "2b0e",
	"./multicare/content/postel.png": "98f5",
	"./multicare/content/postranice.jpg": "9d2c",
	"./multicare/iboard-illustration.png": "bc05",
	"./multicare/logo.png": "cadb",
	"./multicare/logo.svg": "f196",
	"./multicare/multicare.png": "e6ad",
	"./multicare/multicare_product.webp": "d683",
	"./multicare/navigation/key_features--accessories.jpg": "e634",
	"./multicare/navigation/key_features--comfort.jpg": "c959",
	"./multicare/navigation/key_features--controls.jpg": "be1a",
	"./multicare/navigation/key_features--frame_based_lateral_tilt.jpg": "8a53",
	"./multicare/navigation/key_features--mobilization.jpg": "5f1a",
	"./multicare/navigation/key_features--opticare_x.jpg": "5853",
	"./multicare/navigation/key_features--safety.jpg": "5211",
	"./multicare/navigation/modifications--with_mattras.jpg": "ab6d",
	"./multicare/navigation/modifications--without_mattras.jpg": "d34b",
	"./multicare/navigation/solutions--easier_patient_transfer.png": "40de",
	"./multicare/navigation/solutions--improving_pulmonary_outcomes.png": "69e5",
	"./multicare/navigation/solutions--mobilization_patient_early.png": "524e",
	"./multicare/navigation/solutions--moving_immobile_patient.png": "c190",
	"./multicare/navigation/solutions--safe_patient_handling.png": "1a12",
	"./sprint/eleganza4_product.webp": "40ec",
	"./sprint/logo.png": "9636",
	"./sprint/logo.svg": "792d",
	"./sprint/navigation/key_features--accessories.png": "6735",
	"./sprint/navigation/key_features--cardiac_chair.png": "8f00",
	"./sprint/navigation/key_features--foot_controls.png": "6978",
	"./sprint/navigation/key_features--mattress_options.png": "a8c4",
	"./sprint/navigation/key_features--safety.png": "1f5f",
	"./sprint/navigation/key_features--transportation.png": "c5c0",
	"./sprint/navigation/modifications--with_i_drive.png": "7bf8",
	"./sprint/navigation/modifications--with_mattras.png": "d144",
	"./sprint/navigation/modifications--without_i_drive.png": "dba3",
	"./sprint/navigation/modifications--without_mattras.png": "93ce",
	"./sprint/navigation/solution--easy-patient-transportation.png": "b6de",
	"./sprint/navigation/solution--fall-prevention.png": "4155",
	"./sprint/navigation/solution--improve-patient-experience.png": "8991",
	"./sprint/navigation/solution--patient-recovery-improved-experience.png": "dab7",
	"./sprint/navigation/solution--simplify-caregiver-procedures.png": "7a71",
	"./sprint/sprint.png": "f030"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fe";